import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultTargetMonth } from '@/features/contract-and-cost/targetMonth';
export const Route = createFileRoute('/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/')({
  beforeLoad: () => {
    throw redirect({
      to: '/software/contract-and-cost/cost/$targetMonth',
      params: {
        targetMonth: getDefaultTargetMonth()
      }
    });
  }
});